function parsePrice(value) {
    return parseFloat(
        value.replace(/[^\d.,]/g, '') // delete everything except numbers, periods and commas
            .replace(/\s/g, '')      // remove spaces (in some currencies)
            .replace(/\.(?=\d{3,})/g, '') // remove dots if they are 1 thousand separators
            .replace(',', '.')      // replace the comma with a period
    ) * 100; // convert to cents
}

function formatMoney(cents, currencyCode = 'EUR', locale = 'en') {
    const amount = cents / 100;
    return amount.toLocaleString(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

// Main function of shipping calculation
function cartShipping() {
    const shippingBlocks = document.querySelectorAll('.cart-shipping');

    shippingBlocks.forEach(shippingEl => {
        const totalEl = shippingEl.closest('.shipping-cart-wrapper')?.querySelector('.totals__total-value');
        if (!shippingEl || !totalEl) return;

        const minTotal = parseFloat(shippingEl.dataset.minSpend); // in cents
        const total = parsePrice(totalEl.textContent);            // also in cents
        if (isNaN(minTotal) || isNaN(total)) return;

        let progress = (total / minTotal) * 100;
        if (progress > 100) progress = 100;

        const defaultMsgEl = shippingEl.querySelector('.cart-shipping__message_default');
        const defaultMsgElText = shippingEl.querySelector('.cart-shipping__message_default .cart-shipping__message_default_text');
        const successMsgEl = shippingEl.querySelector('.cart-shipping__message_success');
        const progressEl = shippingEl.querySelector('.cart-shipping__progress-current');

        const currencyCode = shippingEl.dataset.currency || 'EUR';
        const locale = shippingEl.dataset.locale || 'en';

        if (minTotal > total) {
            const amount = minTotal - total;
            const rawMsg = shippingEl.dataset.message;
            const message = rawMsg.replace('||amount||', formatMoney(amount, currencyCode, locale));
            if (defaultMsgElText) defaultMsgElText.innerText = message;
            if (successMsgEl) successMsgEl.classList.remove('active');
            if (defaultMsgEl) defaultMsgEl.classList.add('active');
        } else {
            if (defaultMsgEl) defaultMsgEl.classList.remove('active');
            if (successMsgEl) successMsgEl.classList.add('active');
        }

        if (progressEl) {
            progressEl.style.width = progress + '%';
        }
    });
}


window.cartShipping = cartShipping;

document.addEventListener("DOMContentLoaded", () => {
    cartShipping();
});
